import { observer } from 'mobx-react-lite'
import { type JobDetailsViewModel } from '@/features/jobs/details/JobDetailsViewModel'
import { InfoLinesCard } from '@/features/jobs/details/components/InfoLinesCard'

export interface InfoLinesCardContainerProps {
  vm: JobDetailsViewModel
}

export const InfoLinesCardContainer = observer(function InfoLinesCardContainer({
  vm,
}: InfoLinesCardContainerProps) {
  return (
    <InfoLinesCard
      infoLines={vm.job.infoLines.map((line) => ({
        title: line.title,
        content: line.content,
      }))}
    />
  )
})
